import { useContext } from "react";
import { useHistory } from "react-router-dom";
import Apicall from "../api/Apicall";
import { Context } from "../components/containers/context/Context";
import { Base64 } from "js-base64";


export const ValidateToken = async () => {
    const { setUser, idioma, app, user } = useContext(Context);

    const history = useHistory();
 
    try {
        
        if (history.location.search) {
            
            const search = history.location.search.substring(1);
            const splitUrl = search.split("&");
            let urlParam;
            
            if(splitUrl){
                urlParam = {};
                splitUrl.forEach(function(e){
                    if(e.indexOf("=") >= 0){
                        urlParam[e.substring(0,e.indexOf("="))] = e.substring(e.indexOf("=")+1);
                    }
                });
            }

            if (urlParam?.userRedirect) {

                const urlCore = app.apiCore + "/control/LoginControl.jsp";
                const dataToken = new URLSearchParams();
                dataToken.append('opc', 'getTokenSession');

                const respFetch = await fetch(urlCore, {
                    method: 'POST',
                    body: dataToken,
                    credentials: "include"
                }
                );

                const jsonResponse = await respFetch.json();
                
                if (jsonResponse.success) {
                    const userRedirect = jsonResponse.token;
                    const idiomaUser = idioma || urlParam.idioma;
                    const keyClient = urlParam.keyClient ? Base64.decode(decodeURIComponent(urlParam.keyClient)) : undefined;

                    const url = `${app.url}/user/getLoggedUser`;

                    const header = {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${userRedirect}`
                    };

                    const params = {
                        url,
                        "headers": header,
                        "noAuth": true,
                        "noKeyClient": true,
                        user, 
                        app
                    };

                    if (keyClient) {
                        header["KeyClient"] = keyClient;
                        params["data"] = {
                            "KeyClient": keyClient
                        };
                    }

                    const response = await Apicall(params);

                    if (response?.data?.success) {

                        const userData = response?.data?.user ? response.data.user : {};

                        SetValuesSession(idiomaUser, userRedirect,
                            true, userData, keyClient);
                        const usrData = {
                            "userRedirect": userRedirect,
                            "isAuthenticated": true,
                            "idioma": idiomaUser,
                            ...userData
                        }
                        if (keyClient) {
                            usrData["keyClient"] = keyClient;
                        }
                        setUser(usrData);

                    } else {
                        console.error("No es válido");
                        RedirectInvalidUser(app);
                    }
                } else {
                    console.error("No es válido");
                    RedirectInvalidUser(app);
                }
            } else {
                console.error("Faltan parámetros");
                RedirectInvalidUser(app);
            }
        } else {
            console.error("Faltan parámetros");
            RedirectInvalidUser(app);
        }

    } catch (error) {
        console.log(error);
        RedirectInvalidUser(app);
    }
}

const SetValuesSession = (
    idioma,
    userRedirect,
    isAuthenticated,
    userData,
    keyClient
) => {

    sessionStorage.setItem('userRedirect', userRedirect);
    sessionStorage.setItem('isAuthenticated', isAuthenticated);
    sessionStorage.setItem('idioma', idioma);
    sessionStorage.setItem('userData', JSON.stringify(userData));
    keyClient && sessionStorage.setItem('keyClient', keyClient);
}

export const RedirectInvalidUser = (app) => {
    const idioma = sessionStorage.getItem('idioma');
    sessionStorage.clear();
    sessionStorage.setItem('idiomaOut', idioma);
    if(app) {
        window.location.href = `${app.loginFront}/index.html?end=true`;
    }

}

export const ChangeCompany = async ({keyClient, nit, pais, empresa}, user, setUser) => {

    const newUserData = {
        ...user,
        "nit": nit,
        "idPais": pais,
        "nombreEmpresa" : empresa
    }

    SetValuesSession(newUserData.idioma, newUserData.userRedirect,
        true, newUserData, keyClient);
    setUser({ "userRedirect": newUserData.userRedirect, 
        "isAuthenticated" :  newUserData.isAuthenticated ,
        "idioma" : newUserData.idioma, 
        ...newUserData,
        "keyClient" : keyClient
    });
}
